import React from 'react'
import AboutUsSection from '../../components/about/AboutUS'
import TeamSlider from '../../components/about/AboutCard'
import Certifications from '../../components/about/Company'
import Who from '../../components/home/Who'
import ChooseUs from '../../components/home/ChooseUs'
import FaqSection from '../../components/about/FAQ'



const About = () => {
  return (
    <>


      <AboutUsSection />

      <Who />
      <ChooseUs />
      <TeamSlider />
      <Certifications />
      <FaqSection />

    </>
  )
}

export default About